// TODO: [TDT-34] REMOVE this entire file once BE delivers the feature.
// Ticket: https://jira.teladoc.net/browse/TDT-34
// Mock data is only injected in local dev (NODE_ENV === 'development').

export const MOCK_BIA_TASK_ID = 835050;

export const MOCK_BIA_TASK = {
    type: 'CCM',
    id: MOCK_BIA_TASK_ID,
    description: 'Activate body composition mode',
    subContent: "Today's Task",
    code: 'START_TRACKING_BODY_COMPOSITION',
    taskCategoryCode: 'DEVICE',
    taskSource: 'LAUNCHPAD',
    status: 'IN_PROGRESS',
    priority: 2,
    imageId: 'DEVICE',
    imageIdAlt: '',
    createdAt: '2026-03-12T00:00:00Z',
    navigation: {
        webPath: `/task-detail/${MOCK_BIA_TASK_ID}`,
        mobilePath: '',
    },
};

// TODO: [TDT-34] REMOVE this entire MOCK_BIA_TASK_DETAIL block once BE supports
// getTaskDetailById for START_TRACKING_BODY_COMPOSITION.
// When BE is ready, remove the early-return mock in getTaskDetailById in next-steps-api.js.
export const MOCK_BIA_TASK_DETAIL = {
    id: MOCK_BIA_TASK_ID,
    code: 'START_TRACKING_BODY_COMPOSITION',
    status: 'IN_PROGRESS',
    description: 'Activate body composition mode',
    info: 'Want to get a more holistic picture of your health? Activate body composition mode. Select "Go to settings" below. On the next screen, toggle body composition mode to "on". This feature on your scale is a great way to celebrate your wins, even if your weight hasn\'t changed. Body composition mode tells you your body fat and muscle mass percentages. These percentages give more insight into your journey.',
    frequency: 'One time',
    // eslint-disable-next-line camelcase
    behavior_category: {
        title: 'Tracking and Monitoring',
        info: "Keeping track of your health and habits can teach you a lot about your body and lifestyle. It points out patterns or problems. It shows you what you're doing well and what you can do better. It helps you stay motivated and on track. When you understand the impact of your daily choices, you feel more in control.",
    },
    resources: [
        {
            title: 'Explore body composition',
            link: 'https://click.teladochealth.com/OIxw/dt0jdxvt',
        },
        {
            title: 'What is BIA (Bioelectrical Impedance Analysis)?',
            link: 'https://click.teladochealth.com/OIxw/3s5mv30c',
        },
    ],
    goal: {},
    webPath: '/condition-management/body-composition',
    // eslint-disable-next-line camelcase
    nav_button: {
        code: 'WEIGHT_DEVICE_DETAILS',
        label: 'Go to settings',
    },
    preferences: {
        difficulty: {
            options: [],
            value: 0,
        },
        daysSkipped: [1, 3, 7],
    },
    taskCategoryCode: 'DEVICE',
};
